import React from "react"
import { View, Heading, Text } from "@adobe/react-spectrum"
import HierarchyItem from "./HierarchyItem"
import { NotFoundIconSvg } from "../../../utilities/components/Icons"

const HierarchyView = ({ data }) => {
    return (
        <View
            // backgroundColor="celery-50"
            // padding="size-300"
            // borderRadius="large"
            boxShadow="medium"
            overflow="auto"
            width="100%"
        >
            <View minWidth="600px" position="relative" minHeight="40rem" >
                {data?.length > 0 ? (
                    data?.map((item, index) => (
                        <HierarchyItem
                            key={item.id}
                            item={item}
                            level={index}
                            isLast={index === data.length - 1}
                        />
                    ))
                ) : (
                   <div style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "40rem",
                    width: "100%",
                    opacity: 0.5
                   }}>
                    <NotFoundIconSvg/>
                    <Text UNSAFE_style={{
                        fontSize: "24px",
                        fontWeight: "600",
                        color: "#374151",
                        marginBottom: "8px"
                    }}>No Hierarchy Found</Text>
                    <Text UNSAFE_style={{
                            fontSize: "16px",
                            color: "#6B7280",
                            textAlign: "center",
                            maxWidth: "500px",
                        }}
                    >
                        We couldn't find any hierarchy data to display. Please try
                        again later.
                    </Text>
                </div>
                )}
            </View>
        </View>
    )
}

export default HierarchyView
